<section>
  <h3>Show options</h3>
  <div class="sliders">
    <ng-container *ngFor="let option of options">
      <mat-slide-toggle class="slider" [ngModel]="option.isEnabled" (change)="toggleSections(option, $event)">{{ option.text }}</mat-slide-toggle>
      <div class="checkboxes" *ngIf="option.contactsList?.length && option.isEnabled">
        <mat-checkbox class="checkbox" *ngFor="let contact of option.contactsList" [ngModel]="contact.isEnabled" (change)="toggleContacts($event)"
          ><span data-toggle="tooltip" data-placement="top" [title]="contact.contactInfo.company_name">
            {{ contact.contactInfo.company_name }}
          </span></mat-checkbox
        >
      </div>
    </ng-container>
  </div>
</section>
